import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const strategies = {
  canva: {
    title: 't(Import from Canva)',
    text: 't(Import a design from Canva)'
  },
  document: {
    title: 't(Upload a Document)',
    text: 't(Upload a document from your device)'
  }
}

const StrategyToken = ({ value }) => (
  <div className="token">
    <strong><T text={ strategies[value].title } /></strong><br />
    <T text={ strategies[value].text } />
  </div>
)

StrategyToken.propTypes = {
  value: PropTypes.string
}

export default StrategyToken
